import { useTranslation } from 'react-i18next';
import GetQuantity from '../../GetQuantity';

interface FooterDrawerProps {
    price: number;
    quantity: number;
    handleDecrease: () => void;
    handleIncrease: () => void;
    handleAddToCart: () => void;
    onClose: () => void;
}

export default function FooterDrawer({ quantity, handleIncrease, handleDecrease, handleAddToCart, onClose }: FooterDrawerProps) {
    const { t } = useTranslation();

    return (
        <div className="bg-white box-shadow p-4 rounded-2xl">
            <div className="flex justify-between">
                <GetQuantity isWaiter={true} qty={quantity} handleDecrease={() => handleDecrease()} handleIncrease={() => handleIncrease()} />
                <div className="flex gap-2">
                    <button
                        className={`py-3 px-5 rounded-[10px] text-btn bg-danger text-[#FFFFFF] flex items-center gap-2 justify-center`}
                        onClick={onClose}
                    >
                        {t('cancel')}
                    </button>
                    <div
                        className="flex justify-center items-center gap-x-2 bg-primary text-[#FFFFFF] py-3 px-5 rounded-lg cursor-pointer"
                        onClick={handleAddToCart}
                    >
                        <h1
                            className="text-total text-[#FFFFFF]"
                        >
                            {t('Add')}
                        </h1>
                    </div>
                </div>
            </div>
        </div>
    )
}
